import { compareTableValues } from '../../../services/tableState'
import type { AccessibleLocation, SortDirection } from '../../../types/access'

/** Client-side Locations ordering only; backend list contracts are unchanged. */
export function createLocationComparator(locale: string) {
  const names = new Intl.Collator(locale, { numeric: true, sensitivity: 'base' })
  const statuses = new Intl.Collator(locale, { sensitivity: 'base' })
  const name = (row: AccessibleLocation) =>
    [row.name, row.label, row.location_key].find(value => value?.trim())?.trim() || null
  const created = (row: AccessibleLocation) => {
    const raw = (row as AccessibleLocation & { created_at?: string | null }).created_at
    const value = raw ? Date.parse(raw) : NaN
    return Number.isFinite(value) ? value : null
  }
  return (a: AccessibleLocation, b: AccessibleLocation, key: string, direction: SortDirection) => {
    const av = key === 'created' ? created(a) : key === 'status' ? a.status || (a.active === false ? 'inactive' : 'active') : name(a)
    const bv = key === 'created' ? created(b) : key === 'status' ? b.status || (b.active === false ? 'inactive' : 'active') : name(b)
    return compareTableValues(av, bv, key === 'created' ? 'number' : 'text', direction, key === 'status' ? statuses : names)
  }
}
